<template>
  <div class="basic-resume-box">
    <router-link v-if="resumeId" class="blacklink" :to="'/TalentDetail?id='+resumeId+'&type=1'" target="_blank">
      <el-row :gutter="20">
        <el-col :span="9">
          <user-avatar :src="headImage"></user-avatar>
        </el-col>
        <el-col :span="15">
          <div style="line-height: 21px;">
            <div class="info">
              <span class="name noborder">{{fullName}} </span></div>
            <div class="info">
              <span class="noborder">ID: {{userNo}}</span>
            </div>
            <div class="info">
              <span>{{sex}}</span>
              <span class="noborder">{{age}}岁</span>
            </div>
            <div class="info">
              <span>工作{{workYear}}年</span>
              <span class="noborder">{{degree}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="carreer-box">
        <div v-if="currentCompany">当前公司：{{currentCompany}}</div>
        <div v-if="currentPost">当前职位：{{currentPost}}</div>
        <div style="position: relative;">
          期望：<span v-if="expectCity">{{expectCity}}</span>
          <span v-if="expectPost">{{expectPost}}</span>
          <span v-if="expectMinSalary > 0">{{expectMinSalary}}K-{{expectMaxSalary}}K</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
  import {
    letiaoBasicResume
  } from '~/api/resume';
  import UserAvatar from '~/components/UserAvatar';
  export default {
    components: {
      UserAvatar
    },
    props: {
      userId: 0,
    },
    watch: {
      userId(val) {
        this.getBasicResume(val);
      }
    },
    data() {
      return {
        resumeId: 0,
        userNo: '',
        fullName: '',
        headImage: '',
        sex: '',
        age: '',
        workYear: '',
        degree: '',
        liveCity: '',
        currentCompany: '',
        currentPost: '',
        expectCity: '',
        expectPost: '',
        expectMinSalary: '',
        expectMaxSalary: '',
      };
    },
    created() {
      this.getBasicResume(this.userId);
    },
    methods: {
      getBasicResume(userId) {
        var params = {
          userDataId: userId
        };
        letiaoBasicResume(params).then(r => {
          if (r.errcode === 0) {
            var resume = r.data;
            if (resume) {
              this.resumeId = resume.resumeId;
              this.userNo = resume.userNo;
              this.fullName = resume.fullName;
              this.headImage = resume.headImage;
              this.sex = resume.sex;
              this.age = resume.age;
              this.workYear = resume.workYear;
              this.degree = resume.degree;
              this.liveCity = resume.liveCity;
              this.currentCompany = resume.currentCompany;
              this.currentPost = resume.currentPost;
              this.expectCity = resume.expectCity;
              this.expectPost = resume.expectPost;
              this.expectMinSalary = resume.expectMinSalary;
              this.expectMaxSalary = resume.expectMaxSalary;
            }
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>